import tw from "twin.macro";
export const PrimaryButton = tw.button`px-8 py-3 font-bold rounded bg-blue-500 text-gray-100 hocus:bg-white hocus:text-black focus:shadow-outline focus:outline-none transition duration-300`;
